import {
  ActiveVerticalResponse,
  GetBalanceResponse,
  UsersVerticalsResponse,
  RetrieveGameHistoryRequest,
  BannerRetrieveRequest,
  BannerImageResponse,
  GameHistoryListResponse,
  CmsUserListResponse,
  MasterAffiliateTagsResponse,
} from "../models";
import homeApi from "../api/home.api";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import errorModal from "../../../services/errorModal.service";
import { HomePageGameCategoriesResponse } from "../models/response/homePageGameCategoriesResponse";

const homeService = {
  retrieveBanners: async (
    data: BannerRetrieveRequest,
  ): Promise<UnifiedResponse<BannerImageResponse>> => {
    var response = await homeApi.retrieveBanners(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
        return response;

  },

  fetchActiveVerticals: async (): Promise<
    UnifiedResponse<ActiveVerticalResponse>
  > => {
    var response = await homeApi.fetchActiveVerticals();

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  fetchUserVerticals: async (): Promise<
    UnifiedResponse<UsersVerticalsResponse>
  > => {
    var response = await homeApi.fetchUserVerticals();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  fetchUserBalance: async (): Promise<UnifiedResponse<GetBalanceResponse>> => {
    var response = await homeApi.fetchUserBalance();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  fetchGameHistory: async (
    data: RetrieveGameHistoryRequest,
  ): Promise<UnifiedResponse<GameHistoryListResponse>> => {
    return await homeApi.fetchGameHistory(data);
  },

  fetchCmsUserList: async (): Promise<UnifiedResponse<CmsUserListResponse>> => {
    var response = await homeApi.fetchCmsUserList();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message, false);
    }
    return response;
  },

  fetchMasterAffiliateTags: async (): Promise<
    UnifiedResponse<MasterAffiliateTagsResponse>
  > => {
    var response = await homeApi.fetchMasterAffiliateTags();

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  fetchHomePageGameCategories: async (): Promise<UnifiedResponse<HomePageGameCategoriesResponse>> => {
    var response = await homeApi.fetchHomePageGameCategories();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },
};

export default homeService;
